import props from '../../../../redux/props'
import { useSelector } from 'react-redux'
import Container from '../../../UI/Container/Container'
import bg from '../../../../assets/image/home/hero.png'

const Hero = () => {
  const t = useSelector((s) => s[props.TRANSLATION])

  return (
    <div>
      <div
        className="w-screen bg-center h-[50vh] md:h-[80vh] overflow-hidden py-10 bg-cover flex items-center justify-center"
        style={{ backgroundImage: `url(${bg})` }}
      >
        <Container>
          <div className="flex flex-col md:flex-row md:px-10 items-center justify-center gap-10 md:gap-20 h-full">
            <div className="w-full md:flex-1">
              {t.home.hero.text.map((text, i) => (
                <div
                  key={i}
                  className="text-white text-center text-2xl md:text-6xl md:leading-[4.5rem] font-bold uppercase"
                  style={{
                    textShadow: '2px 2px 3px rgba(22,22,22,0.2)',
                  }}
                >
                  {text}
                </div>
              ))}
            </div>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default Hero
